var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activeDetail active " },
    [
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c("van-cell", { attrs: { title: "活动名称" } }, [
            _c("p", { staticClass: "item2" }, [_vm._v(" 活动1")])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "活动日期" } }, [
            _c("p", { staticClass: "item2" }, [
              _vm._v(" 2018-12-20  -  2019-04-30")
            ])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "活动地点" } }, [
            _c("p", { staticClass: "item2" }, [_vm._v(" 上海新天地")])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "预计人数" } }, [
            _c("p", { staticClass: "item2" }, [_vm._v(" 1000")])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "到场人数" } }, [
            _c("p", { staticClass: "item2" }, [_vm._v(" 1000")])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "集客目标" } }, [
            _c("p", { staticClass: "item2" }, [_vm._v(" 1000")])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "集客人数" } }, [
            _c("p", { staticClass: "item2" }, [_vm._v(" 1000")])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "销售目标" } }, [
            _c("p", { staticClass: "item2" }, [_vm._v(" 1000")])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "调查问卷" } }, [
            _c("p", { staticClass: "item2" }, [_vm._v(" 有")])
          ]),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "完成人数" } }, [
            _c("p", { staticClass: "item2" }, [_vm._v(" 唐小西西")])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group group-table" },
        [
          _c(
            "van-cell",
            [
              _c("template", { slot: "title" }, [
                _c("span", { staticClass: "custom-text" }, [
                  _vm._v("实际费用")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mini-text" }, [
                  _vm._v("（未税8000，含税9000）")
                ])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "table van-hairline--surround" }, [
            _c("div", { staticClass: "table-title flex " }, [
              _c("p", { staticClass: "item1" }, [_vm._v("序号")]),
              _vm._v(" "),
              _c("p", { staticClass: "item2" }, [_vm._v("名称")]),
              _vm._v(" "),
              _c("p", { staticClass: "item1" }, [_vm._v("数量")]),
              _vm._v(" "),
              _c("p", { staticClass: "item3" }, [_vm._v("未税费用")]),
              _vm._v(" "),
              _c("p", { staticClass: "item3" }, [_vm._v("含税费用")])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "table-content flex van-hairline--top" }, [
              _c("li", { staticClass: "item1 van-hairline--right" }, [
                _vm._v("1")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "item2 van-hairline--right" }, [
                _vm._v("场地费")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "item1 van-hairline--right" }, [
                _vm._v("1")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "item3 van-hairline--right" }, [
                _vm._v("2000")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "item3 flex" }, [
                _c("p", { staticClass: "item1" }, [_vm._v("3000")])
              ])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "table-content flex van-hairline--top" }, [
              _c("li", { staticClass: "item1 van-hairline--right" }, [
                _vm._v("1")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "item2 van-hairline--right" }, [
                _vm._v("场地费")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "item1 van-hairline--right" }, [
                _vm._v("1")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "item3 van-hairline--right" }, [
                _vm._v("2000")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "item3 flex" }, [
                _c("p", { staticClass: "item1" }, [_vm._v("3000")])
              ])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "table-content flex van-hairline--top" }, [
              _c("li", { staticClass: "item3 van-hairline--right" }, [
                _vm._v("合计")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "item1 van-hairline--right" }),
              _vm._v(" "),
              _c("li", { staticClass: "item3 van-hairline--right" }),
              _vm._v(" "),
              _c("li", { staticClass: "item3" })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex" }, [
            _c("p", { staticClass: "upload-img " }, [
              _c("img", {
                attrs: { src: require("@/assets/img/logo.png"), alt: "" }
              })
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "upload-img " }, [
              _c("img", {
                attrs: { src: require("@/assets/img/logo.png"), alt: "" }
              })
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group group-table" },
        [
          _c(
            "van-cell",
            [
              _c("template", { slot: "title" }, [
                _c("span", { staticClass: "custom-text" }, [
                  _vm._v("当天销售情况")
                ])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "table van-hairline--surround" }, [
            _c("div", { staticClass: "table-title flex " }, [
              _c("p", { staticClass: "item2" }, [_vm._v("序号")]),
              _vm._v(" "),
              _c("p", { staticClass: "item3" }, [_vm._v("产品一级分类")]),
              _vm._v(" "),
              _c("p", { staticClass: "item2" }, [_vm._v("产品名称")]),
              _vm._v(" "),
              _c("p", { staticClass: "item2" }, [_vm._v("金额")])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "table-content flex van-hairline--top" }, [
              _c("li", { staticClass: "item2 van-hairline--right" }, [
                _vm._v("1")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "item3 van-hairline--right" }, [
                _vm._v("甲类")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "item2 van-hairline--right" }, [
                _vm._v("某某某")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "item2 van-hairline--right" }, [
                _vm._v("2000")
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group group-table" },
        [
          _c(
            "van-cell",
            [
              _c("template", { slot: "title" }, [
                _c("span", { staticClass: "custom-text" }, [
                  _vm._v("活动后30天销售情况")
                ])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "table van-hairline--surround" }, [
            _c("div", { staticClass: "table-title flex " }, [
              _c("p", { staticClass: "item2" }, [_vm._v("序号")]),
              _vm._v(" "),
              _c("p", { staticClass: "item3" }, [_vm._v("产品一级分类")]),
              _vm._v(" "),
              _c("p", { staticClass: "item2" }, [_vm._v("产品名称")]),
              _vm._v(" "),
              _c("p", { staticClass: "item2" }, [_vm._v("金额")])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "table-content flex van-hairline--top" }, [
              _c("li", { staticClass: "item2 van-hairline--right" }, [
                _vm._v("1")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "item3 van-hairline--right" }, [
                _vm._v("甲类")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "item2 van-hairline--right" }, [
                _vm._v("某某某")
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "item2 " }, [_vm._v("2000")])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c("van-cell", { attrs: { title: "活动总结" } }),
          _vm._v(" "),
          _c("div", { staticClass: "cell-content" }, [
            _vm._v(
              "\n      这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动这是一个有趣的活动\n    "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c("van-cell", { attrs: { title: "现场照片" } }),
          _vm._v(" "),
          _c("div", { staticClass: "flex" }, [
            _c("p", { staticClass: "upload-img " }, [
              _c("img", {
                attrs: { src: require("@/assets/img/logo.png"), alt: "" }
              })
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "upload-img " }, [
              _c("img", {
                attrs: { src: require("@/assets/img/logo.png"), alt: "" }
              })
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c("van-cell", { attrs: { title: "审批记录" } }),
          _vm._v(" "),
          _c("ul", { staticClass: "steps" }, [
            _c(
              "li",
              { staticClass: "step" },
              [
                _c("van-icon", {
                  staticClass: "step-icon",
                  attrs: { name: "checked", color: "#02c316", size: "20px" }
                }),
                _vm._v(" "),
                _c("div", [
                  _c("p", { staticClass: "flex" }, [
                    _c("span", { staticClass: "item1" }, [
                      _vm._v("2016-07-12 12:40")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item1" }, [_vm._v("唐小小")])
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("审批备注：同意")])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "step" },
              [
                _c("van-icon", {
                  staticClass: "step-icon",
                  attrs: { name: "clear", color: "#e83c39", size: "20px" }
                }),
                _vm._v(" "),
                _c("div", [
                  _c("p", { staticClass: "flex" }, [
                    _c("span", { staticClass: "item1" }, [
                      _vm._v("2016-07-12 12:40")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item1" }, [_vm._v("唐小小")])
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("审批备注：与实际不符")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "flex" }, [
                    _c("img", {
                      staticClass: "step-img",
                      attrs: { src: require("@/assets/img/logo.png") }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "step-img",
                      attrs: { src: require("@/assets/img/logo.png") }
                    })
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "step" },
              [
                _c("van-icon", {
                  staticClass: "step-icon",
                  attrs: { name: "play-circle", color: "#8bc34a", size: "20px" }
                }),
                _vm._v(" "),
                _c("div", [
                  _c("p", { staticClass: "flex" }, [
                    _c("span", { staticClass: "item1" }, [
                      _vm._v("2016-07-12 12:40")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item1" }, [_vm._v("唐小小")])
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("提交备注：一周年吸粉活动")])
                ])
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c("van-cell", { attrs: { title: "审批备注" } }),
          _vm._v(" "),
          _c("van-field", {
            staticClass: "textarea van-hairline--surround",
            attrs: {
              type: "textarea",
              placeholder: "请输入备注内容描述",
              rows: "3",
              autosize: ""
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c(
                "p",
                { staticClass: "upload-img " },
                [
                  _c("img", {
                    attrs: { src: require("@/assets/img/logo.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c("van-icon", {
                    staticClass: "del-icon",
                    attrs: { name: "clear", color: "#e83c39", size: "20px" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-uploader",
                { staticClass: "upload " },
                [
                  _c("van-icon", { attrs: { name: "plus" } }),
                  _vm._v(" "),
                  _c("p", [_vm._v("上传图片")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom-btn flex" }, [
      _c("div", { staticClass: "item1 btn save" }, [_vm._v("拒绝")]),
      _vm._v(" "),
      _c("div", { staticClass: "item1 btn sub" }, [_vm._v("批准")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-076d7780", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-076d7780","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/active/reportApprove.vue
// module id = null
// module chunks = 